<app-sidenav>
    <app-sidebar sidebar [navigation]="navigationData"/>
    <ng-container topbar>
        <app-breadcrumb/>
        <div>
            <app-alerts-menu/>
            <app-navigation-menu [menuData]="APP_NAVIGATION"/>
        </div>
    </ng-container>
    <router-outlet/>
</app-sidenav>

